module.exports = "//static.hsappstatic.net/pricing-pages-ui/static-1.26936/js/img/splash-page/ConnectedCustomerPlatform_Graphic_2x.webp"